import { render, staticRenderFns } from "./CreateTaskFolders.vue?vue&type=template&id=25718daa&"
import script from "./CreateTaskFolders.vue?vue&type=script&lang=js&"
export * from "./CreateTaskFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports